import { render, staticRenderFns } from "./dropdown-item.vue?vue&type=template&id=46c31933&"
import script from "./dropdown-item.vue?vue&type=script&lang=js&"
export * from "./dropdown-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/planorama/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('46c31933')) {
      api.createRecord('46c31933', component.options)
    } else {
      api.reload('46c31933', component.options)
    }
    module.hot.accept("./dropdown-item.vue?vue&type=template&id=46c31933&", function () {
      api.rerender('46c31933', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/surveys/dropdown-item.vue"
export default component.exports